module.exports = __webpack_public_path__ + "static/media/specific-risk-orange.e260bb66.svg";